import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/camera.svg'


const _withScopeId = n => (_pushScopeId("data-v-782c425d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrapper" }
const _hoisted_2 = {
  key: 1,
  for: "img-uploader"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "photo-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "camera icon"
  })
], -1))
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "text-wrapper" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "profession" }
const _hoisted_8 = { class: "profession" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "email-hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_el_skeleton, {
            key: 0,
            class: "fullsize",
            animated: "",
            style: {"--el-skeleton-color":"#AFBEC7"}
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, {
                variant: "circle",
                class: "fullsize"
              })
            ]),
            _: 1
          }))
        : (_ctx.isMyProfile)
          ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
              _createVNode(_component_app_lazy_image, {
                class: "img",
                url: _ctx.photoUrl,
                key: _ctx.photoUrl
              }, null, 8, ["url"]),
              _hoisted_3
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_app_lazy_image, {
                class: "img",
                url: _ctx.photoUrl,
                key: _ctx.photoUrl
              }, null, 8, ["url"])
            ])),
      _withDirectives((_openBlock(), _createElementBlock("input", {
        key: _ctx.fileInputKey,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.savePhoto && _ctx.savePhoto(...args))),
        accept: "image/png, image/jpg, image/jpeg",
        id: "img-uploader",
        class: "img-uploader",
        type: "file",
        ref: "fileInput"
      }, null, 544)), [
        [_vShow, false]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_el_skeleton, {
            key: 0,
            class: "fullsize",
            animated: "",
            style: {"--el-skeleton-color":"#AFBEC7"}
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, { variant: "text" }),
              _createVNode(_component_el_skeleton_item, { variant: "text" })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.fullName), 1),
            _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.profession), 1),
            _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.speciality), 1),
            (_ctx.email && _ctx.isMyProfile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$localize('profile.info.email.hint')), 1),
                  _createElementVNode("h4", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCopy && _ctx.onCopy(...args))),
                    class: "email"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.email) + " ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon icon-copy-content", _ctx.copied ? 'icon-copy-content-success' : 'icon-copy-content'])
                    }, null, 2)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      _createVNode(_component_app_take_photo, {
        image: _ctx.imageToCrop,
        onOnCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageToCrop = {})),
        onOnDone: _ctx.handleCroppedImage,
        singleUpload: "",
        hideOptionsList: ""
      }, null, 8, ["image", "onOnDone"])
    ]))
  ]))
}